// extracted by mini-css-extract-plugin
export default {"container":"src-pages-transfer-components-summary-chart-for-period-styles_container"};